import React from 'react'
import getSvgIcons from './getSvgIcons'
import SvgIcon from './index'

const List = () => {
  const icons = getSvgIcons()
  if (!(icons && typeof icons === 'object' && Object.keys(icons).length > 0)) {
    return ''
  }
  return (
    <div
      style={{
        paddingBottom: '100px',
      }}
    >
      {Object.keys(icons).map((icon, key) => (
        <div
          key={'icon-' + key}
          style={{
            display: 'flex',
            paddingBottom: '20px',
          }}
        >
          <div
            style={{
              flex: 1,
              maxWidth: '40px',
              textAlign: 'center',
            }}
          >
            <SvgIcon
              type={icon}
              className='svg-icon-preview'
              style={{
                maxWidth: '100%',
              }}
            />
          </div>
          <div
            style={{
              flex: 1,
              alignSelf: 'center',
              paddingLeft: '30px',
            }}
          >
            {icon}
          </div>
        </div>
      ))}
    </div>
  )
}

export default List
